export const systemElementKeys = {
  all: ["systemElement"] as const,
  project: (projectId: string) => [...systemElementKeys.all, projectId] as const,
  categorizedEntity: (elementId: string) => [...systemElementKeys.all, "categorizedEntity", elementId] as const,
};
